export default {
	"1e42ed0a7c08b9483c6b6eab3a6dd33d": "Product details page - Click on the coupon"
}
